import { Attr, Model } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

/**
 * Confirm an email address from the signed token in a verification email.
 *
 * Unauthenticated: the user follows the link straight from their inbox and need
 * not be logged in.
 */
@Model()
export default class EmailVerification extends ApplicationRecord {
  static jsonapiType = 'email-verifications';

  static verify(token: string) {
    return new EmailVerification({ token }).save();
  }

  @Attr() token: string;
}

/**
 * The `code` on a failed verification.
 *
 * `expired` - the link is older than 72 hours. Offer a resend.
 * `invalid` - tampered, unknown, or **already used**. A resend will not help.
 *
 * Note `invalid` is what a user gets by clicking the same link twice: verifying
 * clears the nonce the link carries, by design. It usually means "you are
 * already verified", not "something went wrong".
 */
export type VerificationErrorCode = 'expired' | 'invalid';
